import { auth0 } from '../lib/auth0';
import Head from 'next/head';
import MainHome from '../components/home/main-home';

const Home = () => {
  return (
    <>
      <Head>
        <title>PolicyInfluence - A free platform for lobbying and briefing materials</title>
        <meta
          name='description'
          content='PolicyInfluence is a free platform for organisations to share their lobbying and briefing materials with parliamentarians. Find policy asks, research, news releases, and more. '
        />
        <meta
          name='keywords'
          content='policy influence, lobbying, briefing, parliamentarians, policy asks, research, news releases, free platform'
        />
        <meta property='og:title' content='PolicyInfluence - A free platform for lobbying and briefing materials' />
        <meta
          property='og:description'
          content='Share your policy asks, research, news releases, and more with parliamentarians on PolicyInfluence.'
        />
        <meta property='og:image' content='https://cdn.policymogul.com/images/policyinfluence.jpg'></meta>
      </Head>
      <MainHome />
    </>
  );
};

export const getServerSideProps = async ({ req, res }) => {
  const session = await auth0.getSession(req, res);
  if (session) {
    return {
      redirect: {
        destination: '/home',
        permanent: false,
      },
    };
  }
  return {
    props: {},
  };
};
export default Home;
